var _path, _rect, _rect2, _rect3, _rect4, _path2, _path3, _rect5, _rect6, _path4, _path5, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyClients(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 128,
    viewBox: "0 0 110 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 128C85.2711 128 109 104.271 109 75C109 45.7289 85.2711 22 56 22C26.7289 22 3 45.7289 3 75C3 104.271 26.7289 128 56 128Z",
    fill: "#D1D1D1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 52,
    width: 68,
    height: 76,
    rx: 4,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 16,
    width: 68,
    height: 28,
    rx: 4,
    fill: "url(#paint0_linear_756_555)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 11,
    width: 11,
    height: 2,
    rx: 1,
    transform: "rotate(-90 23 11)",
    fill: "#2F343D",
    fillOpacity: 0.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 19,
    width: 11,
    height: 2,
    rx: 1,
    transform: "rotate(180 17 19)",
    fill: "#2F343D",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.22 41.0653C102.927 41.3582 102.927 41.833 103.22 42.1259C103.513 42.4188 103.987 42.4188 104.28 42.1259L106.173 40.2335L108.065 42.1259C108.358 42.4188 108.833 42.4188 109.126 42.1259C109.419 41.833 109.419 41.3582 109.126 41.0653L107.233 39.1728L109.126 37.2803C109.419 36.9874 109.419 36.5126 109.126 36.2197C108.833 35.9268 108.358 35.9268 108.065 36.2197L106.173 38.1121L104.28 36.2197C103.987 35.9268 103.513 35.9268 103.22 36.2197C102.927 36.5126 102.927 36.9874 103.22 37.2803L105.112 39.1728L103.22 41.0653Z",
    fill: "#2F343D",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.157742 42.6353C-0.0524649 42.8455 -0.0524649 43.1863 0.157742 43.3965C0.367948 43.6067 0.70876 43.6067 0.918967 43.3965L2.27712 42.0384L3.63529 43.3965C3.84549 43.6067 4.1863 43.6067 4.39651 43.3965C4.60672 43.1863 4.60672 42.8455 4.39651 42.6353L3.03835 41.2771L4.3966 39.9189C4.6068 39.7087 4.6068 39.3679 4.3966 39.1577C4.18639 38.9474 3.84558 38.9474 3.63537 39.1577L2.27712 40.5159L0.91888 39.1577C0.708673 38.9475 0.367861 38.9475 0.157655 39.1577C-0.0525517 39.3679 -0.0525516 39.7087 0.157655 39.9189L1.5159 41.2771L0.157742 42.6353Z",
    fill: "#2F343D",
    fillOpacity: 0.6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 103.307,
    width: 7.50525,
    height: 1.39773,
    rx: 0.698864,
    transform: "rotate(-45 6 103.307)",
    fill: "#2F343D",
    fillOpacity: 0.6
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 17.8613,
    y: 13.2998,
    width: 11.4,
    height: 1.9,
    rx: 0.95,
    transform: "rotate(-135 17.8613 13.2998)",
    fill: "#2F343D",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 72.6C14.1075 72.6 14.6 72.1075 14.6 71.5C14.6 70.8925 14.1075 70.4 13.5 70.4C12.8925 70.4 12.4 70.8925 12.4 71.5C12.4 72.1075 12.8925 72.6 13.5 72.6ZM13.5 74C14.8807 74 16 72.8807 16 71.5C16 70.1193 14.8807 69 13.5 69C12.1193 69 11 70.1193 11 71.5C11 72.8807 12.1193 74 13.5 74Z",
    fill: "#FF4935"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104 99C104.552 99 105 98.5523 105 98C105 97.4477 104.552 97 104 97C103.448 97 103 97.4477 103 98C103 98.5523 103.448 99 104 99ZM104 101C105.657 101 107 99.6569 107 98C107 96.3431 105.657 95 104 95C102.343 95 101 96.3431 101 98C101 99.6569 102.343 101 104 101Z",
    fill: "#2F343D",
    fillOpacity: 0.6
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 62,
    width: 24,
    height: 4,
    rx: 2,
    fill: "#2F343D",
    fillOpacity: 0.8
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 70,
    width: 39,
    height: 4,
    rx: 2,
    fill: "#2F343D",
    fillOpacity: 0.6
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 24,
    width: 24,
    height: 4,
    rx: 2,
    fill: "#DDDDDD",
    fillOpacity: 0.5
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 32,
    width: 39,
    height: 4,
    rx: 2,
    fill: "white"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 82,
    width: 39,
    height: 4,
    rx: 2,
    fill: "#2F343D",
    fillOpacity: 0.8
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 90,
    width: 28,
    height: 4,
    rx: 2,
    fill: "#2F343D",
    fillOpacity: 0.6
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 102,
    width: 21,
    height: 4,
    rx: 2,
    fill: "#2F343D",
    fillOpacity: 0.8
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 110,
    width: 33,
    height: 4,
    rx: 2,
    fill: "#2F343D",
    fillOpacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_756_555",
    x1: 23.7548,
    y1: 44,
    x2: 77.4443,
    y2: 24.7961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4935"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6759"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyClients);
export default __webpack_public_path__ + "static/media/empty-clients.c821eff251d4b286caf19b27cb6b0fb9.svg";
export { ForwardRef as ReactComponent };